import { Component, OnInit } from '@angular/core';

import { IStrapiDocuments, SignpostData } from 'src/app/interfaces/strapi';

import StrapiService from 'src/app/services/strapi.service';

@Component({
    selector: 'app-signposting-card',
    templateUrl: './signposting-card.component.html',
    styleUrls: ['./signposting-card.component.scss'],
})
export class SignpostingCardComponent implements OnInit {
  public signpostData: SignpostData = <SignpostData>{};

  constructor(public readonly strapi: StrapiService) {}

  ngOnInit(): void {
    this.strapi
      .getDocumentByUID('signposting-cards', 'health-assured-signpost', {
        populate: '*',
      })
      .subscribe((data: IStrapiDocuments<SignpostData>) => {
        this.signpostData = data.data[0].attributes;
      });
  }
}
